<template>
  <div class="pb-5">
    <v-simple-table class="blended-table table-layout table-fixed" id="style-2" fixed-header :height="tableHeight + 'px'">
      <template v-slot:default>
        <thead>
        <tr>
          <th style="min-width: 50px; max-width:50px">
            <v-tooltip
              right
            >
              <template v-slot:activator="{ on, attrs }">
                <img
                  v-bind="attrs"
                  v-on="on"
                  src="../../assets/sort_icon.svg"
                  height="24"
                  width="24"
                  alt=""
                  style="cursor: pointer"
                  @click="handleSortByUpdateAt">
              </template>
              <div>Đang sắp xếp theo thứ tự {{filterForm.sortUpdatedAt === 'desc' ? 'từ mới đến cũ' : 'từ cũ đến mới'}}
                <br>
                theo thời gian chuyển mốc chăm sóc</div>
            </v-tooltip>
          </th>
          <th style="min-width: 50px; max-width:50px; left:0px; text-align: center" class="sroll-left">
            <input
              type="checkbox"
              class="periodically-care-checkbox"
              v-model="filterForm.checkboxAll"
              @change="onChangeCheckboxAll"
            >
          </th>
          <th style="min-width: 120px; max-width:120px; left:50px" class="sroll-left">Mã khách hàng</th>
          <th style="min-width: 295px; left:200px" class="sroll-left">Tên học viên</th>
          <th style="min-width: 120px; max-width:120px; left:495px" class="sroll-left">Tag</th>
          <th style="min-width: 245px; max-width:245px; left:615px" class="sroll-left">Quản lý lớp</th>
          <th>Sale gia hạn</th>
          <th style="width: 180px;">TUTOR</th>
          <th>Hết hạn - Tutor</th>
          <th style="width: 180px;">Duo</th>
          <th style="min-width: 150px; max-width:150px;">Trạng thái CSĐK</th>
          <th>Lịch sử chăm sóc</th>
<!--          <th style="width: 120px;">Thao tác</th>-->
        </tr>
        </thead>
        <transition name="fade" mode="out-in">
          <template v-if="dataBlendedTutor || otherDataBlendedTutor">
            <tbody
              key="first-tbody"
              v-if="dataBlendedTutor.length >0"
            >
            <tr v-for="(item, index) in dataBlendedTutor"
                :key="`${item.id}_${index}`"
                class="bg-hover"
            >
              <!--          <td style="text-align: center; min-width: 50px; max-width:50px">{{index + 1 + (filterForm.page - 1) * filterForm.limit}}</td>-->
              <td style="text-align: center; min-width: 50px; max-width:50px">{{index + 1 + (filterForm.page - 1) * filterForm.limit}}</td>
              <td class="sroll-left" style="left:0px; min-width: 50px; max-width:50px; text-align: center">
                <input type="checkbox" class="periodically-care-checkbox" v-model="item.checkbox"
                       @change="changeItemSelect(item.checkbox)">
              </td>
              <td class="sroll-left" style="left: 50px; min-width: 150px; max-width: 150px">
                <div v-if="item.contact_code" class="d-flex align-center">
                  <img src="../../assets/star-icon.svg" class="mr-2" height="16" width="16" alt="" :style="`visibility: ${item.is_new_call? 'visible': 'hidden'}`">
                  <span>{{item.contact_code}}</span>
                  <div @click.stop="">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          size="small"
                          rounder
                          icon
                          v-on="on"
                          @click="copyContactId(item)"
                        >
                          <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>Copy</span>
                    </v-tooltip>
                  </div>
                </div>
                <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td class="sroll-left student-name" style="min-width: 295px; left:200px" >
                <v-tooltip v-if="item.is_special_care === 1" top>
                  <template v-slot:activator="{ on }">
                    <div class='d-flex justify-space-between' v-on="on">
                      <div class="ml-2 mr-3" style="font-weight: 500; cursor: pointer;color:#4F4F4F" @click="showQuickView(item)">{{item.full_name}}</div>
                      <div class="d-flex">
                        <!-- <img src="../../assets/phone-icon.svg" style="cursor: pointer" height="16" class="mt-1" width="16" alt="" @click="handleExecuteCall(item, item.mobile)"> -->
                        <!-- <v-menu offset-y v-if="item.phoneRelated && item.phoneRelated.length">
                          <template v-slot:activator="{ on: menu, attrs }">
                              <div
                                class="d-flex flex-column align-center"
                                v-bind="attrs"
                                v-on="menu"
                              >
                                <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                              </div>
                          </template>
                          <v-list>
                            <v-list-item
                              @click="handleExecuteCall(item, item.mobile)"
                              class="main-mobile"
                            >
                              <v-list-item-title>{{item.mobile}}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-for="(phone, index) in item.phoneRelated"
                              :key="index"
                              @click="handleExecuteCall(item, phone)"
                              class="sub-mobile"
                            >
                              <v-list-item-title>{{phone}}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <div
                          v-else
                          style="cursor: pointer"
                          @click.stop="handleExecuteCall(item, item.mobile)"
                        >
                          <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                        </div> -->
                        <v-menu offset-y>
                          <template v-slot:activator="{ on: menu, attrs }">
                            <div
                              class="d-flex flex-column align-center"
                              v-bind="attrs"
                              v-on="menu"
                              @click="checkPhoneRelated(item)"
                            >
                              <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                            </div>
                          </template>
                          <v-list>
                            <v-list-item
                              @click="handleExecuteCall(item, item.mobile)"
                              class="main-mobile"
                            >
                              <v-list-item-title>{{formatNormalStylePhone(item.mobile)}}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-for="(phone, index) in contactPhoneRelated"
                              :key="index"
                              @click="handleExecuteCall(item, phone)"
                              class="sub-mobile"
                            >
                              <v-list-item-title>{{formatNormalStylePhone(phone)}}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-tooltip right>
                          <template v-slot:activator="{ on,attrs }">
                            <div
                              v-if="checkSchoolLevelPermission('create-task-blended_create', 'create-task-blended-secondary_create')"
                              v-on="on"
                              v-bind="attrs"
                            >
                              <img src="../../assets/createtask.svg" style="cursor: pointer" class="ml-4" alt="" srcset=""  @click="createTask(item)">
                            </div>
                          </template>
                          <div>Tạo công việc</div>
                        </v-tooltip>
                      </div>
                    </div>
                  </template>
                  <span>Học sinh đang thuộc danh sách chăm sóc đặc biệt</span>
                </v-tooltip>
                <div v-else class="d-flex align-center justify-space-between">
                  <div class="ml-2 mr-3" style="font-weight: 500; cursor: pointer;color:#4F4F4F" @click="showQuickView(item)">{{item.full_name}}</div>
                  <div class="d-flex">
                    <!-- Use when list have key phoneRelated -->
                    <v-menu offset-y v-if="item.phoneRelated && item.phoneRelated.length">
                      <template v-slot:activator="{ on: menu, attrs }">
                        <div
                          class="d-flex flex-column align-center"
                          v-bind="attrs"
                          v-on="menu"
                        >
                          <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                        </div>
                      </template>
                      <v-list>
                        <v-list-item
                          @click="handleExecuteCall(item, item.mobile)"
                          class="main-mobile"
                        >
                          <v-list-item-title>{{formatNormalStylePhone(item.mobile)}}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-for="(phone, index) in item.phoneRelated"
                          :key="index"
                          @click="handleExecuteCall(item, phone)"
                          class="sub-mobile"
                        >
                          <v-list-item-title>{{formatNormalStylePhone(phone)}}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      v-else
                      style="cursor: pointer"
                      @click.stop="handleExecuteCall(item, item.mobile)"
                    >
                      <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                    </div>
                    <!-- Use when list have key phoneRelated -->
                    <!-- <v-menu offset-y>
                      <template v-slot:activator="{ on: menu, attrs }">
                          <div
                            class="d-flex flex-column align-center"
                            v-bind="attrs"
                            v-on="menu"
                            @click="checkPhoneRelated(item)"
                          >
                            <img src="../../assets/phone-icon.svg" height="20" width="20" alt="">
                          </div>
                      </template>
                      <v-list>
                        <v-list-item
                          @click="handleExecuteCall(item, item.mobile)"
                          class="main-mobile"
                        >
                          <v-list-item-title>{{formatNormalStylePhone(item.mobile)}}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-for="(phone, index) in contactPhoneRelated"
                          :key="index"
                          @click="handleExecuteCall(item, phone)"
                          class="sub-mobile"
                        >
                          <v-list-item-title>{{formatNormalStylePhone(phone)}}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu> -->
                    <v-tooltip top>
                      <template v-slot:activator="{ on,attrs }">
                        <div
                          v-if="checkSchoolLevelPermission('create-task-blended_create', 'create-task-blended-secondary_create')"
                          v-on="on"
                          v-bind="attrs"
                        >
                          <img src="../../assets/createtask.svg" style="cursor: pointer" class="ml-2" alt="" srcset=""  @click="createTask(item)">
                        </div>
                      </template>
                      <div>Tạo công việc</div>
                    </v-tooltip>
                  </div>
                </div>
              </td>
              <td class="sroll-left py-2" style="min-width: 120px; max-width:120px; left:495px">
                <template v-if="item.tags && item.tags.length > 0">
                  <div v-for="(tag, index) in item.tags" :key="tag.name" class="mb-1" :class="index === 0 ? 'mt-1' : ''">
                    <div class="tag-box" :style="`background: ${tag.color}; color: ${tag.name === 'CSĐB' ? 'black': 'white'}`">
                      {{tag.name}}
                    </div>
                  </div>
                </template>
                <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td class="sroll-left" style="min-width: 245px; max-width:245px; left:615px">
                <div v-if="item.homeroom_teacher_name">
                  {{ item.homeroom_teacher_name }}
                </div>
                <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td>
                <span v-if="item.extend_sale_name">{{ item.extend_sale_name }}</span>
                <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td>
                <v-tooltip
                  top
                  v-if="mapProgramIdAndProgram[item.curriculum_id]">
                  <template v-slot:activator="{ on,attrs }">
                    <div
                      v-on="on"
                      v-bind="attrs"
                    >
                      {{ handleCutString(mapProgramIdAndProgram[item.curriculum_id].title)}}
                    </div>
                  </template>
                  <div>{{mapProgramIdAndProgram[item.curriculum_id].title}}</div>
                </v-tooltip>
                <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td>
                <div v-if="item.end_date">
                  {{formatDate(item.end_date)}}
                </div>
                <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td>
                <v-tooltip
                  top
                  v-if="item.subject_name">
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-on="on"
                      v-bind="attrs"
                    >{{ handleCutString(item.subject_name) }}</div>
                  </template>
                  <div>{{item.subject_name}}</div>
                </v-tooltip>
                <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td>
                <div
                  v-if="mapCallStatusBlendedTutor[item.call_status_id]"
                  :style="`color: ${mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[item.call_status_id] ? mapCallStatusBlendedTutor[item.call_status_id].color : ''}`"
                >
                  {{
                    mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[item.call_status_id] ? `${changePrefix(mapCallStatusBlendedTutor[item.call_status_id].callType)}-${mapCallStatusBlendedTutor[item.call_status_id].callStatus}` : ''
                  }}
                </div>
                <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
              </td>
              <td>
                <div style="display: flex" v-if="item.routine_history_json">
                  <div
                    class="list-status-history"
                    v-for="status in JSON.parse(item.routine_history_json).slice(-5).reverse()"
                    :key="status.id"
                    :style="generateCss(mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[status.call_status_id] ? mapCallStatusBlendedTutor[status.call_status_id].color : '')"
                  >
                    {{
                      mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[status.call_status_id] ? changePrefix(mapCallStatusBlendedTutor[status.call_status_id].callType) : ''
                    }}
                  </div>
                </div>
                <img v-else src="../../../student_care/assets/empty-data.svg" alt="">
              </td>
              <!--          <td-->
              <!--            :style="`color: ${mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[item.call_status_id] ? mapCallStatusBlendedTutor[item.call_status_id].color : ''}`">-->
              <!--            {{-->
              <!--              mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[item.call_status_id] ? `${mapCallStatusBlendedTutor[item.call_status_id].callType}-${mapCallStatusBlendedTutor[item.call_status_id].callStatus}` : ''-->
              <!--            }}-->
              <!--          </td>-->
              <!--          <td>{{item.end_date ? formatDateLocal(item.end_date) : '&#45;&#45;'}}</td>-->
              <!--          <td>-->
              <!--            <div style="display: flex">-->
              <!--              <div-->
              <!--                class="list-status-history"-->
              <!--                :style="generateCss(mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[status.call_status_id] ? mapCallStatusBlendedTutor[status.call_status_id].color : '')"-->
              <!--                v-for="status in item.routine_history_json"-->
              <!--                :key="status.id">-->
              <!--                {{-->
              <!--                  mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[status.call_status_id] ? mapCallStatusBlendedTutor[status.call_status_id].callType : ''-->
              <!--                }}-->
              <!--              </div>-->
              <!--            </div>-->
              <!--          </td>-->
              <!--          <td>-->
              <!--            <div style="min-width: 62px;text-align: center;">-->
              <!--              <v-icon-->
              <!--                @click="showQuickView(item)"-->
              <!--                class="mr-3"-->
              <!--                color="#00cae3" style="font-size: 25px"-->
              <!--              >-->
              <!--                mdi-alert-circle-->
              <!--              </v-icon>-->
              <!--              <v-icon-->
              <!--                style="font-size: 25px"-->
              <!--                color="#4caf50"-->
              <!--                @click="clickExecuteCall(item, item.mobile)"-->
              <!--              >-->
              <!--                mdi-phone-->
              <!--              </v-icon>-->
              <!--            </div>-->
              <!--          </td>-->
            </tr>
            </tbody>
            <tbody key="second-tbody" v-else-if="otherDataBlendedTutor.length > 0">
            <tr v-for="(item, index) in otherDataBlendedTutor" :key="'otherdata' + index">
              <td colspan="99">
                {{item.text}}
              </td>
            </tr>
            </tbody>
            <div v-else-if="!loading" class="w-100 d-flex justify-center align-center flex-column" style="position: absolute; padding-top: 100px">
              <img src="../../../student_detail_bt/assets/close-icon.png" alt="" class="mb-2">
              <img src="../../../student_detail_bt/assets/no-data-exercise.png" alt="" class="mb-5">
              <span style="color: #828282">
            Không có dữ liệu
          </span>
            </div>
          </template>
          <tbody v-else key="third-tbody">
          <tr v-for="n in 6" :key="'skeleton-loader-' + n">
            <td colspan="99">
              <v-skeleton-loader type="table-row"></v-skeleton-loader>
            </td>
          </tr>
          </tbody>
        </transition>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import BlendedCareRepository from '@/services/BlendedCareRepository';
import { mapActions, mapGetters, mapState } from 'vuex';
import TokenService from '@/helpers/token';
import { TYPE_CURRICULUM_OBJ } from '@/helpers/constant';

export default {
  name: 'PeriodicallyCareTable',
  props: {
    filterForm: {
      type: Object,
      default: () => {
      },
    },
    priorityConfig: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      totalSelected: 0,
      blendedTutorStudents: [],
      contactPhoneRelated: [],
    };
  },
  computed: {
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    ...mapGetters('contact_status', ['mapCallStatus']),
    ...mapGetters(['getDevice']),
    ...mapGetters('blended', ['mapCallStatusBlendedTutor']),
    ...mapState('blended', ['dataBlendedTutor', 'loading', 'otherDataBlendedTutor']),
    tableHeight() {
      const SUB_HEIGHT = 220;
      return this.getDevice.height - SUB_HEIGHT;
    },
  },
  methods: {
    ...mapActions('blended', ['getDataBlendedTutor']),
    ...mapActions('student_care', ['getListProgram', 'getCareContactDetail']),
    handleSortByUpdateAt() {
      if (this.filterForm.sortUpdatedAt === 'asc') {
        this.filterForm.sortUpdatedAt = 'desc';
      } else if (this.filterForm.sortUpdatedAt === 'desc') {
        this.filterForm.sortUpdatedAt = 'asc';
      }
      this.getDataBlendedTutor({
        ...this.filterForm,
        typeBlended: this.priorityConfig,
      });
    },
    copyContactId(item) {
      navigator.clipboard.writeText(item.contact_code ? item.contact_code : item.contact_id).then(
        () => {
          this.$swal({
            type: 'success',
            icon: 'success',
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: 'Sao chép thành công!',
            position: 'top',
          });
        },
      );
    },
    async showQuickView(item) {
      const routeData = this.$router.resolve({ name: 'StudentDetailBlended', params: { id: item.id }, query: { typeCurriculum: TYPE_CURRICULUM_OBJ.ONLINE, taskType: 1, schoolLevel: this.$route.query.schoolLevel } });
      window.open(routeData.href, '_blank');
      if (item.is_new_call) {
        const response = await this.markAsReadUser(item);
        if (response.message === 'Success') {
          // eslint-disable-next-line no-param-reassign
          item.is_new_call = 0;
        }
      }
    },
    changePrefix(text) {
      return text ? text.replace('TA', 'BT') : text;
    },
    async handleCopyCode(code) {
      try {
        await navigator.clipboard.writeText(code);
      } catch ($e) {
        console.log($e);
      }
    },
    async markAsReadUser(item) {
      const response = await BlendedCareRepository.markStudentAsRead({
        id: item.id,
      });
      return response;
    },
    async handleExecuteCall(dataContact, phone) {
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: dataContact.contact_id,
          callcenter_id: user.callCenterId,
          mainId: dataContact.mainId,
          mainMobile: phone,
          store: 'T',
          contactCode: dataContact.contact_code,
          homeroomTeacherId: dataContact.homeroom_teacher_id,
          studentProductId: dataContact.student_product_id,
          callStatusId: dataContact.call_status_id,
          callId: dataContact.call_id,
          module: 'blended',
        };
        Bus.$emit('voice-call-show-popup', data);
        if (dataContact.is_new_call) {
          const response = await this.markAsReadUser(dataContact);
          if (response.message === 'Success') {
            // eslint-disable-next-line no-param-reassign
            dataContact.is_new_call = 0;
          }
        }
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
    },
    handleCutString(str) {
      return str.length <= 15 ? str : `${str.substr(0, 15)}...`;
    },
    changeItemSelect(isChecked) {
      if (isChecked) {
        this.totalSelected += 1;
      } else {
        this.totalSelected -= 1;
      }
    },
    generateCss(hex) {
      if (!hex) return '';
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.substring(0, 7));
      return result ? `background: rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, 0.15); border: 1px solid ${hex}; color: ${hex}` : '';
    },
    onChangeCheckboxAll() {
      if (this.filterForm.checkboxAll) {
        this.totalSelected = this.dataBlendedTutor.length;
      } else {
        this.totalSelected = 0;
      }
      this.dataBlendedTutor.forEach((contact) => {
        const contactTemp = contact;
        contactTemp.checkbox = this.filterForm.checkboxAll && !contact.mainId;
      });
    },
    redirectSpecialCare(item) {
      if (item.is_special_care === 1) {
        const routeData = this.$router.resolve({ name: 'IncomingSchedule', query: { typeCurriculum: TYPE_CURRICULUM_OBJ.ONLINE, contactCode: item.contact_code } });
        window.open(routeData.href, '_blank');
      }
    },
    checkDisableCheckboxAll() {
      const check = this.dataBlendedTutor.find((contact) => contact.is_special_care === 1);
      if (check) {
        return true;
      }
      return false;
    },
    createTask(item) {
      Bus.$emit('openModalTriggerTask', null, item);
    },
    async getContactPhoneRelated(contactId) {
      const res = await this.getCareContactDetail(contactId);
      if (res) {
        this.contactPhoneRelated = res.phoneRelated;
      }
    },
    async checkPhoneRelated(item) {
      await this.getContactPhoneRelated(item.contact_id);
      if (!this.contactPhoneRelated.length) {
        this.handleExecuteCall(item, item.mobile);
      }
    },
  },
};
</script>

<style scoped>
.student-name {
  color: #4263FF;
}
.table-contact tbody tr {
  height: 50px;
}

.table-contact table {
  border: 1px solid #d2d2d2;
}

.table-contact table .bg-hover:hover .child-table td:last-child {
  background: #e0e0e0;
}

.table-contact table .bg-hover:hover tr .scroll-layout-left {
  background: #e0e0e0;
}

.table-contact thead tr {
  height: 35px;
}

.table-contact thead th {
  border-right: 1px solid #d2d2d2;
  font-size: 14px !important;
}

.table-contact thead th:last-child {
  border-right: 0;
}

.table-contact thead .th-id {
  min-width: 50px;
}

.table-contact .child-table td:last-child {
  border-right: 1px solid #d2d2d2;
}

.table-contact .child-table:hover {
  background: rgba(0, 0, 0, 0.11) !important;
}

.table-contact td {
  position: relative;
  border-right: 1px solid #d2d2d2;
  font-size: 14px !important;
  color: #000000;
}

.table-contact td:last-child {
  border-right: 0;
}

.table-contact .table-layout-checkbox {
  position: relative;
}

.table-contact .table-layout-checkbox .v-input--selection-controls__input {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.v-data-table td {
  font-weight: 300;
  padding: 12px 8px;
}

/deep/ tbody td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  text-align: left;
  font-size: 15px !important
}

tbody .action-cell {
  text-align: center;
}

tbody .tr-numerical-order {
  text-align: center;
}

thead th {
  height: 30px;
}

/deep/ .table-layout-checkbox .v-input--selection-controls__input {
  z-index: 1;
}

/deep/ .th_childFullName {
  min-width: 170px;
}

/deep/ .th_parentFullName {
  min-width: 170px;
}

/deep/ .th_description {
  min-width: 200px;
}

/deep/ .th_user {
  min-width: 170px;
}

/deep/ .th_email {
  min-width: 150px;
}

/deep/ .th_detailAddress {
  min-width: 250px;
}

/deep/ .th_productDescription {
  max-width: 250px;
}

/deep/ .th_numberOfCall {
  max-width: 20px;
}

/deep/ .th_appointment {
  min-width: 200px;
}

.appointment-time-wrapper {
  padding: 2px 0px;
  border: thin solid #A9A9A9;
  border-radius: 5px;
  cursor: pointer;
  min-width: 140px;
}

.custom-span-title-study-result {
  color: black;
  font-size: 13px !important;
  text-transform: none !important;
}

/deep/ .btn-show-modal-study-result span.v-btn__content {
  justify-content: normal !important;
}

.icon-comment {
  margin-left: 5px;
}

.btn-show-modal-count-interaction {
  position: absolute;
  top: 20%;
  right: 0%;
}

/deep/ .v-text-field--is-booted .v-input__control .v-input__slot {
  border: 1px solid #d9dbe9 !important;
  height: 40px !important;
  padding: 0 12px !important;
  border-radius: 4px !important;
}

/deep/ .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #d9dbe9 !important;
}

/deep/ .v-text-field--is-booted {
  padding-top: unset !important;
  margin-top: unset !important;
}

/deep/
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
> .v-input__control
> .v-input__slot
fieldset {
  border: 1px !important;
}

.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}

.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}

.ch-tag-trial {
  color: #F2994A;
  border: 1px solid #F2994A;
}

.v-tag-trial {
  color: #4F4F4F;
  border: 1px solid #4F4F4F;
}
.sroll-left {
  /* position: fixed; */
  position: sticky;
  background: #fff;
  border-left: 1px solid #d2d2d2!important;
}

td.sroll-left {
  z-index: 1;
}
/deep/ .v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th.sroll-left {
  border-bottom: 0px !important;
  position: sticky;
  top: 0;
  z-index: 3;
}

@media screen and (max-width: 767px) {
  /deep/ .scroll-layout-left {
    position: unset !important;
  }

  /deep/ .th_mobile, .th_birthday, .th_childFullName, .th_checkbox, .th-id {
    position: sticky !important;
    left: unset !important;
  }
}

.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: unset;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background: #94bdf6 !important;
}

.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 8px !important;
}

.trail-tag {
  padding: 0px 6px;
  font-weight: 400;
  display: inline-block;
  width: 32px;
  text-align: center;
}

.tn-tag-trial {
  color: #219653;
  border: 1px solid #219653;
}

.ch-tag-trial {
  color: #f2994a;
  border: 1px solid #f2994a;
}

.v-tag-trial {
  color: #4f4f4f;
  border: 1px solid #4f4f4f;
}

.list-status-history {
  border: 1px solid;
  margin-right: 5px;
  height: 25px;
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 13px;
  text-align: center;
  padding: 5px 5px 0 5px;
}

.periodically-care-checkbox {
  width: 18px;
  height: 18px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 2px;
  cursor: pointer;
  accent-color: #E91E63;
}
.tag-box{
  font-weight: bold;
  width: fit-content;
  border-radius: 10px;
  font-size: 11px;
  padding: 4px 6px;
}
</style>
